<template>
  <div class="row mt-4" v-if="datos.total > 0">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">

          <div class="mb-3">
            <h6 class="mb-0 panel-section-title">Anónimos vs Registrados</h6>
            <p class="text-xs opacity-7 mb-0">Perfil de compradores por tipo de cuenta</p>
          </div>

          <div class="tc-layout">

            <!-- Donut -->
            <div class="tc-donut-col">
              <QuantyDonutChart
                :labels="['Registrados', 'Anónimos']"
                :values="[datos.registrados, datos.anonimas]"
                :colors="['#f5a623', '#7c8ba1']"
              />
              <div class="tc-donut-legend">
                <div class="tc-legend-item">
                  <span class="tc-legend-dot" style="background:#f5a623"></span>
                  <span class="text-xs">Registrados</span>
                </div>
                <div class="tc-legend-item">
                  <span class="tc-legend-dot" style="background:#7c8ba1"></span>
                  <span class="text-xs">Anónimos</span>
                </div>
              </div>
            </div>

            <!-- Tabla comparativa -->
            <div class="tc-table-col">
              <table class="tc-table">
                <thead>
                  <tr>
                    <th></th>
                    <th class="tc-th--azul">Registrados</th>
                    <th class="tc-th--naranja">Anónimos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="tc-td-label">Ventas</td>
                    <td>
                      <span class="tc-val">{{ datos.registrados }}</span>
                      <span class="tc-pct">{{ pct(datos.registrados) }}%</span>
                    </td>
                    <td>
                      <span class="tc-val">{{ datos.anonimas }}</span>
                      <span class="tc-pct">{{ pct(datos.anonimas) }}%</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="tc-td-label">Ingresos</td>
                    <td>
                      <div class="tc-multi">
                        <span v-if="(datos.importe_reg_eur ?? 0) > 0" class="tc-cur tc-cur--eur">{{ fmtEur(datos.importe_reg_eur) }}</span>
                        <span v-if="(datos.importe_reg_usd ?? 0) > 0" class="tc-cur tc-cur--usd">{{ fmtUsd(datos.importe_reg_usd) }}</span>
                        <span v-if="!(datos.importe_reg_eur > 0) && !(datos.importe_reg_usd > 0)" class="tc-cur tc-cur--eur">—</span>
                      </div>
                      <span class="tc-pct">{{ pctImporte(datos.importe_reg_eur, datos.importe_reg_usd) }}%</span>
                    </td>
                    <td>
                      <div class="tc-multi">
                        <span v-if="(datos.importe_anon_eur ?? 0) > 0" class="tc-cur tc-cur--eur">{{ fmtEur(datos.importe_anon_eur) }}</span>
                        <span v-if="(datos.importe_anon_usd ?? 0) > 0" class="tc-cur tc-cur--usd">{{ fmtUsd(datos.importe_anon_usd) }}</span>
                        <span v-if="!(datos.importe_anon_eur > 0) && !(datos.importe_anon_usd > 0)" class="tc-cur tc-cur--eur">—</span>
                      </div>
                      <span class="tc-pct">{{ pctImporte(datos.importe_anon_eur, datos.importe_anon_usd) }}%</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="tc-td-label">Ticket medio</td>
                    <td>
                      <div class="tc-multi">
                        <span v-if="(datos.ticket_reg_eur ?? 0) > 0" class="tc-cur tc-cur--eur tc-cur--lg">{{ fmtEur(datos.ticket_reg_eur) }}</span>
                        <span v-if="(datos.ticket_reg_usd ?? 0) > 0" class="tc-cur tc-cur--usd tc-cur--lg">{{ fmtUsd(datos.ticket_reg_usd) }}</span>
                        <span v-if="!(datos.ticket_reg_eur > 0) && !(datos.ticket_reg_usd > 0)" class="tc-cur tc-cur--eur tc-cur--lg">—</span>
                      </div>
                    </td>
                    <td>
                      <div class="tc-multi">
                        <span v-if="(datos.ticket_anon_eur ?? 0) > 0" class="tc-cur tc-cur--eur tc-cur--lg">{{ fmtEur(datos.ticket_anon_eur) }}</span>
                        <span v-if="(datos.ticket_anon_usd ?? 0) > 0" class="tc-cur tc-cur--usd tc-cur--lg">{{ fmtUsd(datos.ticket_anon_usd) }}</span>
                        <span v-if="!(datos.ticket_anon_eur > 0) && !(datos.ticket_anon_usd > 0)" class="tc-cur tc-cur--eur tc-cur--lg">—</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="tc-insight" v-if="diferenciaPct !== null">
                <span class="tc-insight__icon">💡</span>
                <span class="tc-insight__text">
                  Los compradores registrados tienen un ticket medio en €
                  <strong>{{ Math.abs(diferenciaPct) }}% {{ diferenciaPct > 0 ? 'mayor' : 'menor' }}</strong>
                  que los anónimos.
                </span>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuantyDonutChart from "@/components/charts/QuantyDonutChart.vue";

export default {
  name: "PanelTipsterTipoCompra",
  components: { QuantyDonutChart },
  props: {
    datos: {
      type: Object,
      default: () => ({
        anonimas: 0, registrados: 0, total: 0,
        importe_anon_eur: 0, importe_anon_usd: 0,
        importe_reg_eur: 0, importe_reg_usd: 0,
        importe_total_eur: 0, importe_total_usd: 0,
        ticket_anon_eur: 0, ticket_anon_usd: 0,
        ticket_reg_eur: 0, ticket_reg_usd: 0,
      }),
    },
  },
  computed: {
    diferenciaPct() {
      const ta = this.datos.ticket_anon_eur;
      const tr = this.datos.ticket_reg_eur;
      if (!ta || !tr) return null;
      return Math.round(((tr - ta) / ta) * 100);
    },
  },
  methods: {
    fmtEur(n) {
      return Number(n || 0).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
    },
    fmtUsd(n) {
      return Number(n || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });
    },
    pct(v) {
      const t = this.datos.total;
      return t > 0 ? ((v / t) * 100).toFixed(1) : "0.0";
    },
    pctImporte(eur, usd) {
      const thisTotal = (eur || 0) + (usd || 0);
      const grandTotal = (this.datos.importe_total_eur || 0) + (this.datos.importe_total_usd || 0);
      return grandTotal > 0 ? ((thisTotal / grandTotal) * 100).toFixed(1) : "0.0";
    },
  },
};
</script>

<style scoped>
.tc-layout {
  display: flex;
  gap: 32px;
  align-items: center;
  flex-wrap: wrap;
}

.tc-donut-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  min-width: 160px;
}

.tc-donut-legend {
  display: flex;
  gap: 14px;
}
.tc-legend-item { display: flex; align-items: center; gap: 5px; }
.tc-legend-dot  { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }

.tc-table-col { flex: 1; min-width: 280px; }

.tc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-bottom: 14px;
}
.tc-table thead th {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 4px 10px;
  text-align: right;
}
.tc-th--azul    { color: var(--q-gold); }
.tc-th--naranja { color: #7c8ba1; }

.tc-table tbody td {
  padding: 8px 10px;
  border-bottom: 1px solid var(--q-border);
  text-align: right;
  vertical-align: middle;
}
.tc-td-label {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: var(--q-muted);
  text-transform: uppercase;
  letter-spacing: .3px;
}
.tc-val { font-weight: 700; color: var(--q-text); display: block; font-family: var(--q-font-mono); font-variant-numeric: tabular-nums; }
.tc-pct { font-size: 10px; color: var(--q-muted); font-family: var(--q-font-mono); font-variant-numeric: tabular-nums; }

/* Multi-moneda dentro de la tabla */
.tc-multi {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}
.tc-cur {
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  font-family: var(--q-font-mono);
}
.tc-cur--lg  { font-size: 15px; }
.tc-cur--eur { color: var(--q-gold); }
.tc-cur--usd { color: #26c6da; }

.tc-insight {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: var(--q-hover);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  color: var(--q-text);
  line-height: 1.5;
}
.tc-insight__icon { font-size: 14px; flex-shrink: 0; }
</style>
